var range = function range(startOrEnd, end) {
  var realStart = end === undefined ? 0 : startOrEnd;
  var length = end === undefined ? startOrEnd : end - startOrEnd;
  if (length < 0) {
    return [];
  }
  return Array.from({
    length: length
  }, function (_, i) {
    return realStart + i;
  });
};

export { range };
//# sourceMappingURL=range.js.map
